import { useEffect, useState } from 'react';
import { getAdminStoreSettings, updateAdminStoreSettings } from '../../api/storeSettings';

const EMPTY = {
  deliveryEnabled: true,
  pickupEnabled: true,
  deliveryPrice: 0,
  freeDeliveryFrom: '',
  pickupAddress: '',
  pickupHint: '',
  deliveryHint: '',
};

export default function AdminStoreSettings() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const s = await getAdminStoreSettings();
        setForm({
          deliveryEnabled: s.deliveryEnabled !== false,
          pickupEnabled: s.pickupEnabled !== false,
          deliveryPrice: Number(s.deliveryPrice || 0),
          freeDeliveryFrom: s.freeDeliveryFrom == null ? '' : Number(s.freeDeliveryFrom),
          pickupAddress: s.pickupAddress || '',
          pickupHint: s.pickupHint || '',
          deliveryHint: s.deliveryHint || '',
        });
      } catch (e) {
        alert(e?.response?.data?.error || 'Не удалось загрузить настройки');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  function setField(key) {
    return (e) => {
      const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
      setForm((p) => ({ ...p, [key]: value }));
    };
  }

  async function save() {
    setSaving(true);
    try {
      const saved = await updateAdminStoreSettings({
        ...form,
        deliveryPrice: Number(form.deliveryPrice) || 0,
        freeDeliveryFrom: form.freeDeliveryFrom === '' ? null : Number(form.freeDeliveryFrom),
      });
      setForm({
        ...saved,
        freeDeliveryFrom: saved.freeDeliveryFrom == null ? '' : saved.freeDeliveryFrom,
      });
      alert('Сохранено');
    } catch (e) {
      alert(e?.response?.data?.error || e?.message || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <p>Загрузка…</p>;

  return (
    <div>
      <h2 className="admin-page-title">Доставка и самовывоз</h2>
      <p className="hint">Эти настройки используются на странице оформления заказа.</p>

      <section className="account__card" style={{ maxWidth: 640 }}>
        <label style={{ display: 'block', marginBottom: 10 }}>
          <input type="checkbox" checked={form.deliveryEnabled} onChange={setField('deliveryEnabled')} /> Доставка включена
        </label>
        <label style={{ display: 'block', marginBottom: 10 }}>
          <input type="checkbox" checked={form.pickupEnabled} onChange={setField('pickupEnabled')} /> Самовывоз включён
        </label>

        <label style={{ display: 'block', marginBottom: 10 }}>
          Стоимость доставки (₽)
          <input type="number" min="0" step="1" value={form.deliveryPrice} onChange={setField('deliveryPrice')} />
        </label>
        <label style={{ display: 'block', marginBottom: 10 }}>
          Бесплатная доставка от суммы товаров (₽, пусто = выкл)
          <input type="number" min="0" step="1" value={form.freeDeliveryFrom} onChange={setField('freeDeliveryFrom')} placeholder="например 5000" />
        </label>
        <label style={{ display: 'block', marginBottom: 10 }}>
          Адрес самовывоза
          <input value={form.pickupAddress} onChange={setField('pickupAddress')} />
        </label>
        <label style={{ display: 'block', marginBottom: 10 }}>
          Подсказка самовывоза
          <textarea rows={2} value={form.pickupHint} onChange={setField('pickupHint')} style={{ width: '100%' }} />
        </label>
        <label style={{ display: 'block', marginBottom: 10 }}>
          Подсказка доставки
          <textarea rows={2} value={form.deliveryHint} onChange={setField('deliveryHint')} style={{ width: '100%' }} />
        </label>

        <button type="button" disabled={saving} onClick={save}>{saving ? 'Сохраняю…' : 'Сохранить'}</button>
      </section>
    </div>
  );
}
